import API from "store/api"

export const generateLongLivedToken = authResponse => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/social/facebook-auth/`)
      .send(authResponse)
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
  return deferred
}

export const facebook = () => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    const FB = window.FB

    // window.fbAsyncInit = function() {
    // console.log(FB)
    FB.init({
      appId: "2558302364483069",
      autoLogAppEvents: true,
      xfbml: true,
      version: "v7.0"
    })

    FB.login(
      function(response) {
        if (response.authResponse) {
          dispatch(generateLongLivedToken(response.authResponse))
            .then(res => {
              // console.log(res)
              resolve(res)
            })
            .catch(error => {
              console.log(error)
              reject(error)
            })
        } else {
          console.log("User cancelled login or did not fully authorize.")
          reject("User cancelled login or did not fully authorize.")
        }
      },
      {
        scope:
          "pages_read_engagement,pages_manage_posts,pages_show_list,public_profile"
      }
    )
  })
  return deferred
}

// export const facebookPost = () => dispatch => {
//   const deferred = new Promise((resolve, reject) => {
//     const FB = window.FB

//     FB.init({
//       appId: "2558302364483069",
//       autoLogAppEvents: true,
//       xfbml: true,
//       version: "v6.0"
//     })

//     FB.api(
//       "/100686788267355/feed",
//       "POST",
//       {
//         access_token:
//           "EAAkWwyZBpvf0BAGKR4ZB3uZB8A4S5IOVmCC6vENvNgUZBuQOdGDHJpcZA6PRYZCDGI4BtbZBgOgcMvfng0ZCozS1JbFLfXs96cHBBR5Yz0FgW0oBL2PG5cGZA4x4VlVZAQrESi5MEicpdXgcetGqHQNyRP203o8uf5KunaSalbhfL8ZB3vxA81EvOVp18tf1PIgtWMZD",
//         message: "This is a test message"
//       },
//       function(response) {
//         console.log(response)
//         if (response && !response.error) {
//           resolve(response)
//         }
//       }
//     )
//   })
//   return deferred
// }



// WEBPACK FOOTER //
// ./src/actions/facebook.js